import styled from 'styled-components';

export const Title = styled.div`
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: ${(props) => (props.theme.theme === 'dark' ? '#ddd' : '#3e3e3e')};
  margin: 0 10px 0 0;

  &.label2 {
    margin: 0 0 0 10px;
  }
`;

export const Content = styled.div`
  /* height: 40px; */
  display: flex;
  align-items: center;
  label {
    position: relative;
    span {
      display: block;
      position: absolute;
      width: 18px;
      height: 18px;
      left: 2px;
      top: 2px;
      background: #fff;
      border-radius: 50%;
      transition: 0.3s;
      cursor: pointer;
      transition: 0.2s;
    }
    input {
      appearance: none;
      margin: 0;
      padding: 0;
      font-size: 16px;
      line-height: 1;
      cursor: pointer;
      width: 40px;
      height: 22px;
      background: #ccc;
      border-radius: 22px;
      vertical-align: middle;

      &:checked {
        background-color: #4caf50;
      }
      &:checked + span {
        left: 18px;
      }
    }
  }
`;
